import appStore from 'store';
import api from './api';
import { STATUS_TYPE, TICKET_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    ticketList: [],
    ticketDetail: {},
    ticketDialogue: [],
    activeTab: 0,
    pagination: {
      page: 1,
      size: 25
    },
    totalCount: 0
  },
  mutations: {
    setTicketList(state, payload) {
      state.ticketList = payload.list.map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status],
          typeText: TICKET_TYPE[item.type]
        };
      });
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setTicketDetail(state, payload) {
      state.ticketDetail = {
        ...payload,
        __status: STATUS_TYPE[payload.status],
        typeText: TICKET_TYPE[payload.type],
        __attachUrl: payload.attachUrl ? payload.attachUrl.split(',') : []
      };
    },
    setTicketDialogue(state, payload) {
      state.ticketDialogue = payload.slice();
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getTicketList(query).then(({ data }) => {
        commit('setTicketList', data);
        commit('setPagination', {
          page: query.page,
          size: query.size
        });
      });
    },
    detail({ commit }, id) {
      api.getTicketDetail(id).then(({ data }) => {
        commit('setTicketDetail', data);
      });
    },
    update({ commit }, ticket) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateTicket(ticket).then(res => {
          resolve(res);
        });
      });
    },
    dialogue({ commit }, id) {
      api.getTicketDialogue(id).then(({ data }) => {
        commit('setTicketDialogue', data);
      });
    },
    createDialogueReply({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.createTicketDialogueReply(data).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('loginUserTicket', store);
